import { useContext, useMemo } from "react";
import { AppContext } from "../dashboard/contexts/app-context";
import canUser from "./can-user";
import Permissions from "./permissions";

export default function useGuarded(
  permissions?: Permissions[],
  preventSuperAdminAccess?: boolean,
  onlySuperAdminAccess?: boolean
) {
  const { user } = useContext(AppContext);
  const allowed = useMemo(() => {
    if (onlySuperAdminAccess) return !!user?.is_super_admin;
    if (preventSuperAdminAccess && user?.is_super_admin) return false;
    return canUser(user, ...(permissions ?? []));
  }, [permissions, preventSuperAdminAccess, onlySuperAdminAccess, user]);
  return allowed;
}
